import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';

import { FirebaseService } from 'src/app/services/firebase/firebase.service';
import { LoggingChannels, LoggingService } from 'src/app/services/logging/logging.service';
import { MobileService } from 'src/app/services/mobile/mobile.service';
import { StreamService } from 'src/app/services/stream/stream.service';

export enum SettingsTabs {
  you = 'menu.you',
  changePassword = 'menu.change_password',
  mediaSettings = 'room.room_menu.media_settings',
}

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  public activeTab?: SettingsTabs;
  public requestedMediaPermissions = false;
  public modal: any;

  constructor(
    private logging: LoggingService,
    private modalCtrl: ModalService,
    private mobile: MobileService,
    private firebase: FirebaseService,
    private stream: StreamService,
    private router: Router,
  ) {}

  public navigateToProfile(tab?: SettingsTabs): void {
    this.router.navigate(['/account']);
  }

  public setActiveTab(tab: SettingsTabs) {
    this.activeTab = tab;

    if (tab === SettingsTabs.mediaSettings && !this.requestedMediaPermissions) {
      return this.requestMediaPermissions();
    }
  }

  public dismissModal() {
    if (this.modal) {
      this.modal.dismiss();
    }
  }

  public requestMediaPermissions() {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => {
          track.stop();
          stream.removeTrack(track);
        });
        this.requestedMediaPermissions = true;
      })
      .catch((error) => {
        this.logging.log('ProfileService: error in media permissions', LoggingChannels.RoomFeature, error);
        this.requestedMediaPermissions = true;
      });
  }

  public hasMediaPermissions(): boolean {
    return !!(this.stream.videoInputId && this.stream.audioInputId);
  }
}
